import React from "react";
import "./Dashboard.css";

// Component Imports
import Hero from "../components/Hero";
import About from "../components/About";
import Services from "../components/Services";
import Projects from "../components/Projects";
// ❌ Removed Footer import since App.jsx handles it globally now

/**
 * Dashboard Component
 * Acts as the main landing page/home container.
 */
const Dashboard = () => {
  return (
    <main className="dashboard-container">
      {/* Hero Section: Entry point with CTA */}
      <Hero />
      
      {/* Content Sections */}
      <section id="about">
        <About />
      </section>
      
      <section id="services">
        <Services />
      </section>
      
      <section id="projects">
        <Projects />
      </section>
      
      {/* ❌ Removed <Footer /> from here to prevent duplication */}
    </main>
  );
}

export default Dashboard;